import { useApi } from '../composables/useApi'
import { URLS } from '../constants/urls'

export default function notificacaoService() {
	const api = useApi()

	async function getAllNotifications(params) {
		return await api.query(URLS.api_notificacao, params, { cache: false })
	}

	return {
		getAllNotifications,
		...api,
	}
}
